import angular from 'angular';

angular
    .module('resumption')

    .controller('AlertModalCtrl', [
        '$scope',
        '$uibModalInstance',
        'batchAlreadyTreated',
        'batchBeingTreated',
        function($scope, $uibModalInstance, batchAlreadyTreated, batchBeingTreated) {
            $scope.batchsAlreadyTreated = batchAlreadyTreated;
            $scope.batchsBeingTreated = batchBeingTreated;

            $scope.exclude = function() {
                if ($scope.form.$valid) {
                    $uibModalInstance.close('exclude');
                }
            };

            $scope.continuProcess = function() {
                if ($scope.form.$valid) {
                    $uibModalInstance.close('continuProcess');
                }
            };

            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
